import React from "react";
import ParticlesBackground from "./ParticlesBackground";
import "./BlogHero.css";

const BlogHero = ({ isDarkMode }) => {
  return (
    <section className={`heroabout blog-hero ${isDarkMode ? "dark" : "light"}`}>
      
      {/* 🌐 PARTICLES */}
      <ParticlesBackground isDarkMode={isDarkMode} />

      {/* 📝 CONTENT */}
      <div className="content-left">
        <div className="text-container with-line">
          <h1 className="about-heading">AstraSight Blog</h1>
          <p className="about-paragraph">
            Insights on <strong>web development, cybersecurity, software</strong>{" "}
            and digital growth across Africa.
          </p>
        </div>
      </div>

    </section>
  );
};

export default BlogHero;
